import { processImages } from "@utils/process-images"
import { truncateTitle } from "@utils/truncate"
import { graphql, useStaticQuery } from "gatsby"

export const useResourcesMenu = () => {
  const { images, blog } = useStaticQuery(
    graphql`
      query MenuLogoQuery {
        images: allDirectusFiles(
          filter: {
            directus_id: {
              in: [
                "b9c999df-d4dd-47d8-b0f1-63a0f7391b53"
                "07a99c63-10ab-4a46-b377-6fdb54bc1ef7"
                "3ce41c96-ab4e-44f7-8d94-e5f2dbb95390"
                "09a6a2d6-aaca-4331-acb7-48fe7669e820"
                "0dc294aa-1921-46cb-8b6e-fc277eba9419"
                "51c9409c-10d0-40dc-9ca7-a2d3374ab997"
                "18f70809-7de7-4b2a-8bc3-7316a514202d"
                "8c0e0ded-54b0-4afb-816c-540a5b4f92f0"
              ]
            }
          }
        ) {
          edges {
            node {
              directus_id
              cdn
              id
              placeholder
              title
            }
          }
        }
        blog: allBlog(
          limit: 2
          sort: { fields: date, order: DESC }
          filter: { status: { eq: "published" } }
        ) {
          edges {
            node {
              id
              slug
              title
            }
          }
        }
      }
    `
  )

  const logos = processImages(images.edges)
  const blogLinks = blog.edges.map(({ node: link }) => ({
    link: `/${link.slug}`,
    name: truncateTitle(link.title),
  }))
  return {
    logos,
    blog: blogLinks,
  }
}
